export const profileRiskAveragedTotals = [24500, 28882, 1235, 980, 120];

export const profileRiskData = [8200, 7223, 422, 2888, 232]